import { useDispatch, useSelector } from "react-redux";
import { getResource } from "../../../Redux/resource/resource.action";
import {
  assessmentHistory,
  futureAssignment,
  getSubjectChapter,
} from "../../../Redux/test/test.action";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { staticIcons } from "../../../utils/assessmentSubjectIcons";
import { formatDateandTime } from "../../../utils/utils";
import { getCodingStats } from "../../../Redux/coding/code.action";

const DashboardBody = () => {
  const nav = useNavigate();
  const dispatch = useDispatch();

  const [history, setHistory] = useState([]);
  const [mergedCards, setMergedCards] = useState([]);
  const [futureAssgnData, setFutureAssgnData] = useState(null);

  const languageColors = [
    { dot: "#3B82F6", bg: "#DBEAFE" }, // blue
    { dot: "#22C55E", bg: "#86EFAC" }, // green
    { dot: "#EF4444", bg: "#FCA5A5" }, // red
  ];

  const codingStats = useSelector(
    (state) => state?.CodeManager?.coding_stats?.top_3_languages,
  );

  const futureAssgnStore = useSelector(
    (state) => state?.TestManager?.futureAssignment,
  );
  const assessmentHistoryStore = useSelector(
    (state) => state?.TestManager?.assignmentHistory?.history,
  );

  const activeTaskNumber = useSelector(
    (state) => state?.TestManager?.futureAssignment?.length,
  );

  useEffect(() => {
    dispatch(getResource());
    dispatch(getSubjectChapter());
    dispatch(assessmentHistory());
    dispatch(futureAssignment());
    dispatch(getCodingStats());
  }, [dispatch]);

  useEffect(() => {
    if (futureAssgnStore) {
      setFutureAssgnData(futureAssgnStore);
    }
  }, [futureAssgnStore]);

  useEffect(() => {
    if (assessmentHistoryStore?.length > 0) {
      setHistory(assessmentHistoryStore);
    } else {
      setHistory([]);
    }
  }, [assessmentHistoryStore]);

  useEffect(() => {
    if (history?.length > 0) {
      const mergedData = history.map((item) => {
        const matchedIcon = staticIcons.find(
          (icon) => icon.subject?.toLowerCase() === item.subject?.toLowerCase(),
        );
        return {
          ...item,
          img: matchedIcon ? matchedIcon.img : null,
        };
      });
      setMergedCards(mergedData);
    }
  }, [history]);

  return (
    <div className="dashboard-page">
      <h1 className="fw900 fz28">Dashboard</h1>
      <div className="dashboard">
        <div className="dashboard__grad-section">
          <div className="bdrs30 w-100 banner">
            <div className="banner__left">
              <h2 className="fw900 fz44">8/10 Free Generations</h2>
              <p className="fw400 fz16">
                {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. */}
              </p>
              <button className="btn btn-solid btn-solid--orange">
                <span className="fw500 fz14">Upgrade</span>
              </button>
            </div>
            <div className="banner__right">
              <img
                src="./assets/images/inner-pages/layout/dashboard-top-gradient-bg.png"
                alt=""
                className="illustration"
              />
            </div>
          </div>
          <div className="w-100 title-bar m-title-bar hide-above-992 hide-below-768">
            <div className="title-bar__text">
              <h2 className="fw700 fz28 mb-1">Coding Performances</h2>
              <p className="grayText fz16 fw400 mb-0">
                {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. */}
              </p>
            </div>
            <div className="title-bar__img">
              <button className="border-0 bg-transparent p-0 rounded-circle">
                <img
                  src="./assets/images/inner-pages/icons/icon-three-dots-horizontal.svg"
                  alt=""
                />
              </button>
            </div>
          </div>
          <div
            className="performances hide-below-768"
            style={{
              backgroundColor: "#f8ebcc",
            }}
          >
            <div className="bdrs30 performances__left">
              <div className="w-100 title-bar hide-below-992">
                <div className="title-bar__text">
                  <h2 className="fw700 fz28 mb-1">Coding Performances</h2>
                  <p className="grayText fz16 fw400 mb-0">
                    {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. */}
                  </p>
                </div>
                {/* <div className="title-bar__img">
                  <button className="border-0 bg-transparent p-0 rounded-circle">
                    <img
                      src="./assets/images/inner-pages/icons/icon-three-dots-horizontal.svg"
                      alt=""
                    />
          
                  
                  </button>
                </div> */}
                <div className="history-title">
                  <a
                    className="fz18 fw500 see-all"
                    onClick={() => nav("/coding-report")}
                  >
                    See All
                  </a>
                </div>
              </div>
              <div
                className="bdrs30 chart-block progress-block-dashboard"
                style={{
                  backgroundColor: "white",
                }}
              >
                <div className="bdrs20 chart-block__legends">
                  <ul className="w-100 m-0 list-inline">
                    {codingStats?.length ? (
                      codingStats.map((item, index) => {
                        const color =
                          languageColors[index % languageColors.length];
                        const score = item?.average_score ?? 0;

                        return (
                          <li key={item?.language || index}>
                            <div className="w-100 pair">
                              <div
                                className="dot dot--beige"
                                style={{ backgroundColor: color.dot }}
                              >
                                <span />
                              </div>
                              <div className="fw700 fz16 l-text text-capitalize">
                                {item?.language?.toLowerCase()==="cpp" ? "C++" : item?.language?.toLowerCase()==="csharp" ? "C#" :item?.language}
                              </div>
                              <div
                                className="w-100 bdrs20 ms-auto d-progress d-progress--beige"
                                style={{
                                  position: "relative",
                                  height: "15px",
                                  background: color.bg,
                                  borderRadius: "20px",
                                  overflow: "hidden",
                                }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                    height: "100%",
                                    width: `${Math.min(score, 100)}%`,
                                    background: color.dot,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent:
                                      score === 100 ? "center" : "flex-end",
                                    paddingRight: score === 100 ? 0 : "6px",
                                    color: "#fff",
                                    fontSize: "10px",
                                    fontWeight: "bold",
                                    boxSizing: "border-box",
                                    borderRadius: "20px",
                                  }}
                                >
                                  {score}%
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      })
                    ) : (
                      <li className="text-center grayText fz14 py-2">
                        No coding data available
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>

            <div className="bdrs30 performances__right">
              <div className="m-auto chart-block__donut">
                <div
                  className="inner-text"
                  style={{
                    backgroundColor: "#fec4ad",
                  }}
                >
                  <h4 className="fw900 fz44">
                    {activeTaskNumber ? activeTaskNumber : 0}
                  </h4>
                  <p className="mb-0 fz12 fw400">Active Tasks</p>
                </div>
                {/* chart here */}
                <div className="chart-container">
                  <canvas id="donutChartDashboard" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="dashboard__dark-green">
          <div className="h-100 bdrs40 fut-assignments">
            <h2 className="text-white fw700 fz28">Future Assignment</h2>

            <ul className="list-inline mb-0 f-assign-list">
              {futureAssgnData?.length > 0 ? (
                futureAssgnData.map((d, index) => (
                  <li key={index}>
                    <div
                      className="f-assign"
                      onClick={() => nav("/test")}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="f-assign__title">
                        <div className="img-cover">
                          <img
                            // src="./assets/images/inner-pages/icons/icon-fut-01.svg"
                            src={
                              staticIcons?.find(
                                (s) =>
                                  s?.subject?.toLowerCase() ===
                                  d?.subject?.toLowerCase(),
                              )?.img
                            }
                            alt=""
                          />
                        </div>

                        <h3 className="fw700 fz24 text-white mb-0">
                          {d?.subject}
                        </h3>
                      </div>

                      <p className="mb-0 fz16 fw400 text-white d-flex align-items-center">
                        <span className="d-flex align-items-center">
                          <img
                            src="./assets/images/inner-pages/icons/icon-clock--blue.svg"
                            alt=""
                            className="me-1"
                          />
                          <span className="ff2 fw500 fz16">
                            {`${d?.duration} mins`}
                          </span>
                        </span>

                        <span className="ff2 fw500 fz16 ms-auto">
                          {formatDateandTime(d?.start_time)}
                        </span>
                      </p>
                    </div>
                  </li>
                ))
              ) : (
                <li>
                  <div className="f-assign">
                    <div className="f-assign__title">
                      <div className="img-cover">
                        <img  src="./assets/subject-logo/future_book.png" alt="" />
                      </div>

                      <h3 className="fw700 fz24 text-white mb-0">
                        No Future assignment available.
                      </h3>
                    </div>

                    <p className="mb-0 fz16 fw400 text-white">
                      Once assignment is recorded, it will appear here for your
                      reference.
                    </p>
                  </div>
                  {/* <p className="mb-0 fz16 fw400 text-white d-flex align-items-center">No assignment available right now.</p> */}
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="bdrs28 dashboard__history">
          <div className="history-title">
            <h2 className="fw700 fz28">History Table</h2>
            <a className="fz18 fw500 see-all" onClick={() => nav("/test")}>
              See All
            </a>
          </div>
          <nav className="tabs">
            {/* <div className="selector" />
            <a href="#" data-body="ht1" className="fz16 fw500 active-tab">
              History Table
            </a> */}
          </nav>

          <section className="tab-body">
            <div className="ht1">
              <ul className="w-100 list-unstyled h-table-list">
                {mergedCards?.length > 0 ? (
                  mergedCards?.map((m) => (
                    <li>
                      <button className="w-100 border-0 ts03 h-data select">
                        <div className="rounded-circle img-cover img-cover--purple">
                          {/* <img
                        src="./assets/images/inner-pages/icons/icon-math.svg"
                        alt=""
                      /> */}
                          <img src={m?.img} alt="icon" />
                        </div>
                        <div className="text">
                          {/* <h4 className="fz16 fw500">
                            {`Test Your ${m?.subject || ""} Knowledge`}. Here
                            you can get the questions related to {m?.chapter}.
                            Questions can be mcqs, short answers or fill in the
                            blanks. Try to attempt all the questions.
                          </h4> */}
                          <h4 className="fz16 fw500">
                            {`${m?.subject || ""} Assessment completed for "${m?.chapter}".`}{" "}
                            You can view this test in your assessment history.
                          </h4>
                          <div className="fz10 fw500 time">
                            {formatDateandTime(m?.created_at)}
                          </div>
                        </div>
                      </button>
                    </li>
                  ))
                ) : (
                  <ul className="w-100 list-unstyled h-table-list">
                    <li>
                      <button className="w-100 border-0 ts03 h-data select">
                        <div className="rounded-circle img-cover img-cover--purple">
                          <img
                            // src="./assets/images/inner-pages/icons/icon-math.svg"
                            alt=""
                          />
                        </div>
                        <div className="text">
                          <h4 className="fz16 fw500">
                            No history data is available at the moment. Once
                            assessment is recorded, it will appear here for your
                            reference.
                          </h4>
                          <div className="fz10 fw500 time"></div>
                        </div>
                      </button>
                    </li>
                  </ul>
                )}
              </ul>
            </div>
          </section>
        </div>
        <div className="bdrs28 pt-0 dashboard__m-stats hide-above-768">
          <nav className="pb-0 m-tabs">
            <div className="m-selector" />
            <a href="#" data-body="m-score" className="fz16 fw500 m-active-tab">
              Your Score
            </a>
            <a href="#" data-body="t-perform" className="fz16 fw500">
              Coding Performances
            </a>
          </nav>
          <section className="m-tab-body">
            <div className="m-score pt-3">
              <div className="bdrs20 mt-0 score-block score-block--yellow">
                <div className="score-block__content">
                  <div className="stats">
                    <div className="img-cover">
                      <img
                        src="./assets/images/inner-pages/icons/icon-stopwatch.svg"
                        alt=""
                      />
                    </div>
                    <h4 className="fz28 fw500">26 h 45 min</h4>
                  </div>
                  <p className="fz18 fw500 grayText mb-0">
                    Track you study time on Platform
                  </p>
                </div>
                {/* Bar chart */}
                <div className="score-block__chart chart--bar">
                  <canvas id="m-barchart" />
                </div>
              </div>
              <div className="bdrs20 score-block score-block--orange">
                <div className="score-block__content">
                  <div className="stats">
                    <div className="img-cover">
                      <img
                        src="./assets/images/inner-pages/icons/icon-four-dots.svg"
                        alt=""
                      />
                    </div>
                    <h4 className="fz28 fw500 text-white">169</h4>
                  </div>
                  <p className="fz18 fw500 text-white mb-0">
                    Number of total task Completed
                  </p>
                </div>
                <div className="score-block__chart chart--sparkline">
                  {/* Sparkline chart */}
                  <canvas
                    id="m-lineChart"
                    width={260}
                    height={130}
                    style={{
                      display: "block",
                      boxSizing: "border-box",
                      height: 65,
                      width: 130,
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="t-perform pt-3">
              <div className="performances">
                <div className="bdrs30 p-0 performances__left">
                  <div className="w-100 title-bar">
                    <div className="title-bar__text">
                      <h2 className="fw700 fz28 mb-1">Coding Performances</h2>
                      <p className="grayText fz16 fw400 mb-0">
                        {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. */}
                      </p>
                    </div>
                    <div className="title-bar__img">
                      <button className="border-0 bg-transparent p-0 rounded-circle">
                        <img
                          src="./assets/images/inner-pages/icons/icon-three-dots-horizontal.svg"
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="bdrs30 chart-block progress-block-dashboard">
                    <div className="bdrs20 chart-block__legends">
                      <ul className="w-100 m-0 list-inline">
                        <li>
                          <div className="w-100 pair">
                            <div className="dot dot--beige">
                              <span />
                            </div>
                            <div className="fw700 fz16 l-text">Python</div>
                            <div
                              className="w-100 bdrs20 ms-auto d-progress d-progress--beige"
                              style={{
                                backgroundColor: "#DBEAFE",
                                position: "relative",
                              }}
                            >
                              <span />
                              <span
                                style={{
                                  backgroundColor: "black",
                                  position: "absolute",
                                }}
                              >
                                80%
                              </span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="w-100 pair">
                            <div className="dot dot--limegreen">
                              <span />
                            </div>
                            <div className="fw700 fz16 l-text">React</div>
                            <div className="w-100 bdrs20 ms-auto bg-white d-progress d-progress--lime">
                              <span />
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="w-100 pair">
                            <div className="dot dot--orange">
                              <span />
                            </div>
                            <div className="fw700 fz16 l-text">Angular</div>
                            <div className="w-100 bdrs20 ms-auto bg-white d-progress d-progress--orange">
                              <span />
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="bdrs30 performances__right">
                  <div className="m-auto chart-block__donut">
                    <div className="inner-text">
                      <h4 className="fw900 fz44">39</h4>
                      <p className="mb-0 fz12 fw400">Active Tasks</p>
                    </div>
                    {/* chart here */}
                    <div className="chart-container">
                      <canvas id="m-donutChartDashboard" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className="bdrs28 dashboard__score hide-below-768">
          <h2 className="fw900 fz28 mb-2 text-white">Latest Scores</h2>

          {history?.length > 0 ? (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              {history
                .slice()
                .sort(
                  (a, b) =>
                    new Date(b?.submitted_at) - new Date(a?.submitted_at),
                )
                .slice(0, 3)
                .map((item, index) => {
                  const colors = ["#FBBF24", "#FB923C", "#38BDF8"]; // yellow, orange, blue rotation
                  const bg = colors[index % colors.length];

                  return (
                    <div
                      key={item?.assignment_id || index}
                      className="bdrs20"
                      style={{
                        backgroundColor: bg,
                        padding: "16px 20px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                      }}
                    >
                      <h4
                        className="fw700"
                        style={{
                          fontSize: "19px",
                          color: "white",
                          margin: 0,
                        }}
                      >
                        {item?.subject}
                      </h4>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span
                          className="fz14 fw400"
                          style={{
                            color: "white",
                            opacity: 0.9,
                            fontSize: "14px",
                          }}
                        >
                          Chapter
                        </span>
                        <span
                          className="fz14 fw500"
                          style={{ color: "white", fontSize: "14px" }}
                        >
                          {Array.isArray(item?.chapter)
                            ? item.chapter.join(", ")
                            : item?.chapter}
                        </span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span
                          className="fz14 fw400"
                          style={{
                            color: "white",
                            opacity: 0.9,
                            fontSize: "14px",
                          }}
                        >
                          Maximum Marks
                        </span>
                        <span
                          className="fz14 fw500"
                          style={{ color: "white", fontSize: "14px" }}
                        >
                          {item?.maximum_marks}
                        </span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span
                          className="fz14 fw400"
                          style={{
                            color: "white",
                            opacity: 0.9,
                            fontSize: "14px",
                          }}
                        >
                          Marks Obtained
                        </span>
                        <span
                          className="fz14 fw500"
                          style={{ color: "white", fontSize: "14px" }}
                        >
                          {item?.obtained_marks}
                        </span>
                      </div>

                      {/* <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span className="fz14 fw400" style={{ color: "white", opacity: 0.9 }}>
                  Total Questions
                </span>
                <span className="fz14 fw500" style={{ color: "white" }}>
                  {item?.total_questions}
                </span>
              </div> */}
                    </div>
                  );
                })}
            </div>
          ) : (
            <p className="fz16 fw400 text-white mb-0">
              No assessment available right now.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
export default DashboardBody;
